<template>
  <div v-if="show" data-cy="erro-container">
    <slot name="title">
      <div class="m-5 text-center text-danger" data-cy="erro-icon-container">
        <font-awesome-icon
          size="10x"
          :icon="['far', 'times-circle']"
          data-cy="erro-icon"
        ></font-awesome-icon>
      </div>
    </slot>

    <b-alert class="text-center" variant="danger" show data-cy="erro-alert">
      <slot data-cy="erro-message"></slot>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
};
</script>

<style scoped></style>
